import React from 'react';
import PropTypes from 'prop-types';
import { Form, Modal, Row, Col, Button, Input } from 'antd';

const RequestRetractModal = ({
  title,
  isOpen,
  onCancel,
  form,
  handleSubmit,
}) => (
  <Modal title={title} visible={isOpen} onCancel={onCancel} footer={null}>
    <Form form={form} onFinish={handleSubmit}>
      <Form.Item label="Reason for retract" name="reason">
        <Input.TextArea />
      </Form.Item>
      <Row justify="end" gutter={12}>
        <Col>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Col>
      </Row>
    </Form>
  </Modal>
);

RequestRetractModal.propTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.any,
  handleSubmit: PropTypes.func.isRequired,
};

export default RequestRetractModal;
